import axios from 'axios';
import headers from './api-gateway-headers';

export default {
  async get(path) {
    // Block any metrics API calls
    if (path.includes('/metrics')) {

      return Promise.resolve({ data: { metrics: {} } });
    }
    
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + path,
        { headers: this.getHeaders() }
      );

      if (response.status >= 200 && response.status < 300) {
        return response;
      } else {
        throw new Error(response.statusText || "Unknown error occurred");
      }
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        throw new Error(error.response?.data?.message || error.message || "Request failed");
      } else {
        throw new Error("An unexpected error occurred");
      }
    }
  },

  async patch(path, payload) {
    try {
      const response = await axios.patch(
        process.env.REACT_APP_API_URL + path,
        payload,
        { headers: this.getHeaders() }
      );

      if (response.status >= 200 && response.status < 300) {
        return response;
      } else {
        throw new Error(response.statusText || "Unknown error occurred");
      }
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        throw new Error(error.response?.data?.message || error.message || "Request failed");
      } else {
        throw new Error("An unexpected error occurred");
      }
    }
  },

  async patchPublic(path, payload) {
    try {
      const response = await axios.patch(
        process.env.REACT_APP_API_URL + path,
        payload,
        { headers: headers.getPublicHeaders() }
      );

      if (response.status >= 200 && response.status < 300) {
        return response;
      } else {
        throw new Error(response.statusText || "Unknown error occurred");
      }
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        throw new Error(error.response?.data?.message || error.message || "Request failed");
      } else {
        throw new Error("An unexpected error occurred");
      }
    }
  },

  async post(path, payload) {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + path,
        payload,
        { headers: this.getHeaders() }
      );

      if (response.status >= 200 && response.status < 300) {
        return response;
      } else {
        throw new Error(response.statusText || "Unknown error occurred");
      }
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        throw new Error(error.response?.data?.message || error.message || "Request failed");
      } else {
        throw new Error("An unexpected error occurred");
      }
    }
  },

  async put(path, payload) {
    try {
      const response = await axios.put(
        process.env.REACT_APP_API_URL + path,
        payload,
        { headers: this.getHeaders() }
      );

      if (response.status >= 200 && response.status < 300) {
        return response;
      } else {
        throw new Error(response.statusText || "Unknown error occurred");
      }
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        throw new Error(error.response?.data?.message || error.message || "Request failed");
      } else {
        throw new Error("An unexpected error occurred");
      }
    }
  },

  async delete(path, payload) {
    try {
      const response = await axios.delete(
        process.env.REACT_APP_API_URL + path,
        { headers: this.getHeaders(), data: payload }
      );

      if (response.status >= 200 && response.status < 300) {
        return response;
      } else {
        throw new Error(response.statusText || "Unknown error occurred");
      }
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        throw new Error(error.response?.data?.message || error.message || "Request failed");
      } else {
        throw new Error("An unexpected error occurred");
      }
    }
  },

  async deletePublic(path, payload) {
    try {
      const response = await axios.delete(
        process.env.REACT_APP_API_URL + path,
        { headers: headers.getPublicHeaders(), data: payload }
      );

      if (response.status >= 200 && response.status < 300) {
        return response;
      } else {
        throw new Error(response.statusText || "Unknown error occurred");
      }
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        throw new Error(error.response?.data?.message || error.message || "Request failed");
      } else {
        throw new Error("An unexpected error occurred");
      }
    }
  },

  getHeaders() {
	return headers.getAuthHeaders();
  },
};
